import React from 'react';
import { Link } from 'react-router-dom';
import { Content } from '../../types/content';
import Card from './Card';
import Avatar from './Avatar';
import ContentActions from './ContentActions';
import { formatRelativeTime } from '../../utils/formatters';
import { useTheme } from '../../contexts/ThemeContext';
import MediaContent from '../content/MediaContent';
import TextContent from '../content/TextContent';
import TagList from '../content/TagList';

interface ContentCardProps {
  content: Content;
  onLike?: () => void;
  onComment?: () => void;
  onShare?: () => void;
  onClick?: () => void;
  compact?: boolean;
}

export default function ContentCard({
  content,
  onLike,
  onComment,
  onShare,
  onClick,
  compact = false
}: ContentCardProps) {
  const { theme } = useTheme();

  return (
    <Card 
      onClick={onClick} 
      variant="hover"
      className="group transition-transform duration-200 hover:-translate-y-0.5"
    >
      <div className="p-2.5 space-y-2.5">
        {/* Author Info */}
        <div className="flex items-center space-x-2">
          <Link to={`/user/${content.author.id}`}>
            <Avatar src={content.author.avatar} alt={content.author.username} size="sm" />
          </Link>
          <div className="min-w-0">
            <Link 
              to={`/user/${content.author.id}`}
              className={`text-xs font-medium hover:underline ${
                theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
              }`}
            >
              @{content.author.username}
            </Link>
            <div className="flex items-center space-x-1">
              <span className={`text-[10px] ${
                theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
              }`}>
                gocity.me
              </span>
              <span className={`text-[10px] ${
                theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
              }`}>
                • {formatRelativeTime(content.createdAt)}
              </span>
            </div>
          </div>
        </div>

        {/* Media */}
        <MediaContent content={content} />

        {/* Text Content */}
        <TextContent content={content} />

        {/* Tags */}
        <TagList tags={content.tags} />

        {/* Actions */}
        <ContentActions
          content={content}
          onLike={onLike}
          onComment={onComment}
          onShare={onShare}
          compact={compact}
        />
      </div>
    </Card>
  );
}